import { Box, Text, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Card = styled(Box)`
  border-radius: ${({ theme }) => theme.border_radius.card};
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  background: ${({ theme }) => getThemeColor('white', theme)};
  box-shadow: ${({ theme }) => theme.box_shadow.card};

  overflow: hidden;
  position: relative;
  min-height: 200px;
`

export const IconContainer = styled(Box)`
  border-radius: 10px;
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};

  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 12px;
  height: 48px;
  width: 48px;
  justify-content: center;
  align-items: center;
`
export const CardValue = styled(Text)`
  p {
    font-size: 36px;
    font-weight: 500;
    line-height: 44px;
  }
`
